import type { AudioEngine } from '../audio/engine';
import type { UnifiedGridVisualizer } from '../ui/visualizer';
import { updatePlayIcon } from '../ui/icons';
import { updateStatus } from '../ui/status';

/**
 * Update audio engine parameters from UI sliders
 */
export function updateAudioParams(audioEngine: AudioEngine): void {
  const tempo = parseInt((document.getElementById('tempo-slider') as HTMLInputElement).value);
  const density = parseInt((document.getElementById('density-slider') as HTMLInputElement).value);
  const mood = parseInt((document.getElementById('mood-slider') as HTMLInputElement).value);

  audioEngine.updateParams({ tempo, density, mood, variation: 50 });
}

/**
 * Randomize all audio parameters
 */
export function randomizeParams(audioEngine: AudioEngine): void {
  const density = Math.floor(Math.random() * 100);
  const mood = Math.floor(Math.random() * 100);
  const tempo = Math.floor(Math.random() * 120) + 60;

  (document.getElementById('density-slider') as HTMLInputElement).value = String(density);
  (document.getElementById('mood-slider') as HTMLInputElement).value = String(mood);
  (document.getElementById('tempo-slider') as HTMLInputElement).value = String(tempo);

  document.getElementById('density-value')!.textContent = `${density}%`;
  document.getElementById('mood-value')!.textContent = `${mood}`;
  document.getElementById('tempo-value')!.textContent = `${tempo}`;

  // Update params and trigger full randomization for maximum variety
  audioEngine.updateParams({ density, mood, tempo, variation: Math.random() * 100 });
  audioEngine.randomize();
}

/**
 * Toggle playback on/off
 */
export function togglePlayback(
  audioEngine: AudioEngine,
  unifiedVisualizer: UnifiedGridVisualizer
): void {
  if (audioEngine.getIsPlaying()) {
    audioEngine.stop();
    unifiedVisualizer.stop();
    updatePlayIcon(false);
    updateStatus('Paused', false);
  } else {
    audioEngine.start();
    unifiedVisualizer.start();
    updatePlayIcon(true);
    updateStatus('Playing', true);
  }
}
